import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateFuelingServiceStoreIds } from '../../api/fueling-service.ts';
import { UpdateFuelingServiceStoreIdsRequest } from '../../api/requests/fueling-service-request.ts';

export default function useUpdateFuelingServiceStoreIds(): UseMutationResult<
  Awaited<ReturnType<typeof updateFuelingServiceStoreIds>>,
  Error,
  UpdateFuelingServiceStoreIdsRequest
> {
  return useMutation({
    mutationFn: updateFuelingServiceStoreIds,
  });
}
